const TaskFormField = React.memo(function TaskFormField(props){
    const {
        formItem,
        value,
        buttons,
        showLabelAsPlaceholder,
        countryId,
        indexFromParent,
        onChange,
    } = props;

    const change = React.useCallback((name, value) => {
        onChange(value);
    }, [onChange]);

    let type = 'text';
    if (formItem.FieldType.alias === 'Checkbox') type = 'checkbox';
    if (formItem.FieldType.alias === 'Boolean') type = 'boolean';
    if (formItem.FieldType.alias === 'YesNo') type = 'yesNo';
    if (formItem.FieldType.alias === 'Date') type = 'date';
    if (formItem.FieldType.alias === 'Time') type = 'time';
    if (formItem.FieldType.alias === 'Decimal') type = 'decimal';
    if (formItem.FieldType.alias === 'Number') type = 'number';
    if (formItem.FieldType.alias === 'TextArea') type = 'textArea';
    if (formItem.FieldType.alias === 'HtmlEditor') type = 'html';
    if (formItem.FieldType.alias === 'TinyMCE') type = 'html';
    if (formItem.FieldType.alias === 'TextBox') type = 'textBox';
    if (formItem.FieldType.plugin === 'Datagroups') type = 'datagroup';
    if (formItem.FieldType.plugin === 'People' && formItem.FieldType.alias === 'Person') type = 'people';
    if (formItem.FieldType.plugin === 'People' && formItem.FieldType.alias === 'HouseholdMember') type = 'householdMember';
    if (formItem.ProcessFormItem.item_type === 'person') {
        if (formItem.ProcessFormItem.person_field === 'id') type = 'number';
        if (formItem.ProcessFormItem.person_field === 'email') type = 'email';
        if (formItem.ProcessFormItem.person_field === 'birthday') type = 'birthday';
        if (formItem.ProcessFormItem.person_field === 'gender') type = 'gender';
    }
    if (formItem.ProcessFormItem.item_type === 'secondary_email') {
        if (formItem.ProcessFormItem.person_field === 'email_type_id') type = 'emailType';
    }
    if (formItem.ProcessFormItem.item_type === 'address') {
        if (formItem.ProcessFormItem.person_field === 'address_type_id') type = 'addressType';
        if (formItem.ProcessFormItem.person_field === 'location_country_id') type = 'addressLocationCountry';
        if (formItem.ProcessFormItem.person_field === 'location_state_id') type = 'addressLocationState';
    }
    if (formItem.ProcessFormItem.item_type === 'phone') {
        if (formItem.ProcessFormItem.person_field === 'default') type = 'phoneDefault';
        if (formItem.ProcessFormItem.person_field === 'phone_type_id') type = 'phoneType';
    }
    if (formItem.ProcessFormItem.item_type === 'instant_messenger' && formItem.ProcessFormItem.person_field === 'instant_messenger_type_id') type = 'instantMessengerType';
    if (formItem.ProcessFormItem.item_type === 'social_network' && formItem.ProcessFormItem.person_field === 'social_media_type_id') type = 'socialNetworkType';

    let taskFieldProps = {
        name: formItem.ProcessFormItem.id,
        type,
        value,
        buttons,
        onChange: change,
        required: Boolean(formItem.ProcessFormItem.is_required),
        instructions: _.get(formItem, 'ProcessFormItem.instructions', null),
    };

    const label = Boolean(_.get(formItem, 'ProcessFormItem.label')) ? _.get(formItem, 'ProcessFormItem.label') : null;
    const yesLabel = Boolean(_.get(formItem, 'ProcessFormItem.settings.yesLabel')) ? _.get(formItem, 'ProcessFormItem.settings.yesLabel') : null;
    const noLabel = Boolean(_.get(formItem, 'ProcessFormItem.settings.noLabel')) ? _.get(formItem, 'ProcessFormItem.settings.noLabel') : null;

    const showYesExplanation = Boolean(_.toInteger(_.get(formItem, 'ProcessFormItem.settings.yesExplanation')) === 1);
    const yesExplanationLabel = Boolean(_.get(formItem, 'ProcessFormItem.settings.yesExplanationLabel')) ? _.get(formItem, 'ProcessFormItem.settings.yesExplanationLabel') : null;
    const yesExplanationRequired = Boolean(_.toInteger(_.get(formItem, 'ProcessFormItem.settings.yesExplanationRequired')) === 1);
    const yesMaxLength = Boolean(_.get(formItem, 'ProcessFormItem.settings.yesMaxLength')) ? _.toInteger(_.get(formItem, 'ProcessFormItem.settings.yesMaxLength')) : null;
    const showNoExplanation = Boolean(_.toInteger(_.get(formItem, 'ProcessFormItem.settings.noExplanation')) === 1);
    const noExplanationLabel = Boolean(_.get(formItem, 'ProcessFormItem.settings.noExplanationLabel')) ? _.get(formItem, 'ProcessFormItem.settings.noExplanationLabel') : null;
    const noExplanationRequired = Boolean(_.toInteger(_.get(formItem, 'ProcessFormItem.settings.noExplanationRequired')) === 1);
    const noMaxLength = Boolean(_.get(formItem, 'ProcessFormItem.settings.noMaxLength')) ? _.toInteger(_.get(formItem, 'ProcessFormItem.settings.noMaxLength')) : null;

    const boxLabel = Boolean(_.get(formItem, 'ProcessFormItem.settings.boxLabel')) ? _.get(formItem, 'ProcessFormItem.settings.boxLabel') : null;
    const hideLabel = Boolean(_.get(formItem, 'ProcessFormItem.settings.hideLabel', false));
    const minValue = Boolean(_.get(formItem, 'ProcessFormItem.settings.minValue')) ? _.toInteger(_.get(formItem, 'ProcessFormItem.settings.minValue')) : null;
    const maxValue = Boolean(_.get(formItem, 'ProcessFormItem.settings.maxValue')) ? _.toInteger(_.get(formItem, 'ProcessFormItem.settings.maxValue')) : null;
    const minLength = Boolean(_.get(formItem, 'ProcessFormItem.settings.minLength')) ? _.toInteger(_.get(formItem, 'ProcessFormItem.settings.minLength')) : null;
    const maxLength = Boolean(_.get(formItem, 'ProcessFormItem.settings.maxLength')) ? _.toInteger(_.get(formItem, 'ProcessFormItem.settings.maxLength')) : null;
    const showCharacterCounter = Boolean(_.toInteger(_.get(formItem, 'ProcessFormItem.settings.showCharacterCounter', 0)));
    const browserSpellcheck = Boolean(_.toInteger(_.get(formItem, 'ProcessFormItem.settings.browser_spellcheck', 0)) > 0);
    const rows = Boolean(_.get(formItem, 'ProcessFormItem.settings.rows')) ? _.toInteger(_.get(formItem, 'ProcessFormItem.settings.rows')) : null;
    const multiMin = Boolean(_.get(formItem, 'ProcessFormItem.multi_min')) ? _.toInteger(_.get(formItem, 'ProcessFormItem.multi_min', 0)) : null;
    const multiMax = Boolean(_.get(formItem, 'ProcessFormItem.multi_max')) ? _.toInteger(_.get(formItem, 'ProcessFormItem.multi_max', 0)) : null;
    const isMulti = Boolean(_.get(formItem, 'ProcessFormItem.is_multi', false));

    if (label && !showLabelAsPlaceholder) {
        _.set(taskFieldProps, 'label', label);
    }

    if (label && showLabelAsPlaceholder) {
        _.set(taskFieldProps, 'placeholder', label);
    }

    if (type === 'boolean') {
        if (yesLabel) _.set(taskFieldProps, 'yesLabel', yesLabel);
        if (noLabel) _.set(taskFieldProps, 'noLabel', noLabel);
        _.set(taskFieldProps, 'indexFromParent', indexFromParent);
    }

    if(type === 'yesNo'){
        if (taskFieldProps.value === null) _.set(taskFieldProps, 'value', {option: null, explanation: ''});
        if (yesLabel) _.set(taskFieldProps, 'yesLabel', yesLabel);
        if (showYesExplanation) _.set(taskFieldProps, 'showYesExplanation', showYesExplanation);
        if (yesExplanationLabel) _.set(taskFieldProps, 'yesExplanationLabel', yesExplanationLabel);
        if (yesExplanationRequired) _.set(taskFieldProps, 'yesExplanationRequired', yesExplanationRequired);
        if (yesMaxLength) _.set(taskFieldProps, 'yesMaxChars', yesMaxLength);
        if (noLabel) _.set(taskFieldProps, 'noLabel', noLabel);
        if (showNoExplanation) _.set(taskFieldProps, 'showNoExplanation', showNoExplanation);
        if (noExplanationLabel) _.set(taskFieldProps, 'noExplanationLabel', noExplanationLabel);
        if (noExplanationRequired) _.set(taskFieldProps, 'noExplanationRequired', noExplanationRequired);
        if (noMaxLength) _.set(taskFieldProps, 'noMaxChars', noMaxLength);
        _.set(taskFieldProps, 'indexFromParent', indexFromParent);
    }

    if (type === 'checkbox') {
        _.set(taskFieldProps, 'checked', value !== null ? Boolean(value) : Boolean(_.get(formItem, 'ProcessFormItem.settings.checked')));
        if (boxLabel) _.set(taskFieldProps, 'boxLabel', boxLabel);
        if (hideLabel) _.set(taskFieldProps, 'label', null);
    }

    if (type === 'date') {
        if (minValue) _.set(taskFieldProps, 'minValue', minValue);
        if (maxValue) _.set(taskFieldProps, 'maxValue', maxValue);
    }

    if (type === 'decimal') {
        if (minValue) _.set(taskFieldProps, 'minValue', minValue);
        if (maxValue) _.set(taskFieldProps, 'maxValue', maxValue);
    }

    if (type === 'number') {
        if (minValue) _.set(taskFieldProps, 'minValue', minValue);
        if (maxValue) _.set(taskFieldProps, 'maxValue', maxValue);
    }

    if (type === 'text') {
        if (minLength) _.set(taskFieldProps, 'minLength', minLength);
        if (maxLength) _.set(taskFieldProps, 'maxLength', maxLength);
        if (showCharacterCounter) _.set(taskFieldProps, 'showCharacterCounter', showCharacterCounter);
    }

    if (type === 'html') {
        if (maxLength) _.set(taskFieldProps, 'maxLength', maxLength);
        if (showCharacterCounter) _.set(taskFieldProps, 'showCharacterCounter', showCharacterCounter);
        _.set(taskFieldProps, 'browserSpellcheck', browserSpellcheck);
    }

    if (type === 'textArea') {
        if (minLength) _.set(taskFieldProps, 'minLength', minLength);
        if (maxLength) _.set(taskFieldProps, 'maxLength', maxLength);
        if (showCharacterCounter) _.set(taskFieldProps, 'showCharacterCounter', showCharacterCounter);
        if (rows) _.set(taskFieldProps, 'rows', rows);
    }

    if (type === 'time') {
        if (minValue) _.set(taskFieldProps, 'minValue', minValue);
        if (maxValue) _.set(taskFieldProps, 'maxValue', maxValue);
    }


    if (type === 'datagroup') {
        if (isMulti) _.set(taskFieldProps, 'isMulti', isMulti);
        if (multiMin) _.set(taskFieldProps, 'multiMin', multiMin);
        if (multiMax) _.set(taskFieldProps, 'multiMax', multiMax);
        _.set(taskFieldProps, 'renderAs', _.get(formItem, 'ProcessFormItem.namespace'));
        _.set(taskFieldProps, 'displayPath', _.get(formItem, 'ProcessFormItem.settings.displayField', null));
        _.set(taskFieldProps, 'datagroupAlias', _.get(formItem, 'FieldType.alias', null));
        _.set(taskFieldProps, 'orderBy', _.get(formItem, 'ProcessFormItem.settings.orderByField', null));
        _.set(taskFieldProps, 'orderDirection', _.get(formItem, 'ProcessFormItem.settings.orderDirectionField', null));
        _.set(taskFieldProps, 'autoFlexColumns', _.get(formItem, 'ProcessFormItem.settings.columnFlex') === 'true');
        _.set(taskFieldProps, 'columns', parseInt(_.get(formItem, 'ProcessFormItem.settings.groupColumns', null)));
        _.set(taskFieldProps, 'datagroupParentAlias', _.get(formItem, 'FieldType.parent.alias', null));
        _.set(taskFieldProps, 'parentFilterBy', _.get(formItem, 'FieldType.parent.filterBy', null));
        _.set(taskFieldProps, 'groupPath', _.get(formItem, 'ProcessFormItem.settings.groupByField', null));
        _.set(taskFieldProps, 'indexFromParent', indexFromParent);
    }

    if (type === 'textBox') {
        _.set(taskFieldProps, 'value', _.get(formItem, 'ProcessFormItem.settings.value', null));
    }

    if (type === 'people') {
        // settings.user_group_ids: only offer members of these user groups (TaskFormFieldTypePerson)
        _.set(taskFieldProps, 'userGroupIds', _.get(formItem, 'ProcessFormItem.settings.user_group_ids', null));
    }

    if(type === 'addressLocationState'){
        _.set(taskFieldProps, 'countryId', countryId);
    }

    //useRenderDebug(`TaskFormField|${_.get(formItem, 'ProcessFormItem.name', 'unknown')}`, {props, change});

    return <TaskField {...taskFieldProps}/>;
});

TaskFormField.propTypes = {
    formItem: PropTypes.object,
    value: PropTypes.any,
    buttons: PropTypes.any,
    showLabelAsPlaceholder: PropTypes.bool,
    countryId: PropTypes.any,
    indexFromParent: PropTypes.number,
    onChange: PropTypes.func,
};

TaskFormField.defaultProps = {
    formItem: null,
    value: [null],
    buttons: null,
    showLabelAsPlaceholder: false,
    countryId: null,
    indexFromParent: null,
    onChange: (name, value) => {},
};

TaskFormField.displayName = 'TaskFormField';